import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { GuideReportVO } from 'src/app/shared/models/GuideReportVO';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-guides-reports',
  templateUrl: './guides-reports.component.html',
  styleUrls: ['./guides-reports.component.scss'],
  providers: [MessageService, ConfirmationService]

})
export class GuidesReportsComponent implements OnInit {

  lstGuides: GuideReportVO[];
  selectedGuide : GuideReportVO;
  loading: boolean = true;

  @ViewChild(Table) private dataTable: Table;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private tovpilUtils: TovpilUtilsService,
    private apiService: ApiService) { }

  ngOnInit(): void {
    this.loadAllGuides();
  }


  loadAllGuides() {
    
    this.apiService.getGuidesReport({}).then(
      data => {
        this.lstGuides = data;
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        console.error(error);
      });

  }

  exportExcel() {
    

    let dataToExport;

    if(this.dataTable.filteredValue){
      dataToExport = this.dataTable.filteredValue;
    }else{
      dataToExport = this.lstGuides;
    }

    
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(dataToExport);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "guides-report");
    });
}

saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '-export-' + new Date().getTime() + EXCEL_EXTENSION);
    });
}
goBack(){
  window.close();
}; 
}
